// TODO: Document/Rework the approach by VRBOSHOP-1987
// Required to tie MAB reward event payload from the last evaluation with a following action on PDP
const MAB_PAYLOAD_ITEM = 'edap:mabEventJson';
const SEARCH_FAILS_COUNT = 'searchFailsCount';
const ADDITIONAL_SEARCH_RETRIES_LIMIT = 2;

const setItem = (key, value) => {
    try {
        return window.sessionStorage.setItem(key, value);
    } catch (e) {
        return null;
    }
};

const resetMabSessionPayload = () => {
    if (window && window.sessionStorage) {
        window.sessionStorage.removeItem(MAB_PAYLOAD_ITEM);
    }
};

const resetSearchFailsSessionPayload = () => {
    if (window && window.sessionStorage) {
        window.sessionStorage.removeItem(SEARCH_FAILS_COUNT);
    }
};

const getJSONItem = (key) => {
    try {
        return JSON.parse(window.sessionStorage.getItem(key));
    } catch (e) {
        return null;
    }
};

const getSearchRetriesLeft = () => {
    const searchFailsCount = getJSONItem(SEARCH_FAILS_COUNT);

    return searchFailsCount === null
        ? ADDITIONAL_SEARCH_RETRIES_LIMIT
        : searchFailsCount;
};

export {
    setItem,
    getJSONItem,
    resetMabSessionPayload,
    resetSearchFailsSessionPayload,
    getSearchRetriesLeft,
    MAB_PAYLOAD_ITEM,
    SEARCH_FAILS_COUNT,
    ADDITIONAL_SEARCH_RETRIES_LIMIT
};
